(function () {
  var q = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var qa = function (selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  };

  var normalize = function (value) {
    return String(value == null ? '' : value).toLowerCase();
  };

  var splitTags = function (value) {
    return value ? value.split('|').filter(Boolean) : [];
  };

  var includesAll = function (list, required) {
    if (!required.length) return true;
    return required.every(function (value) {
      return list.indexOf(value) !== -1;
    });
  };

  function initSalonList(root) {
    var grid = q('[data-aw-salon-list-grid]', root);
    var countEl = q('[data-aw-salon-list-count]', root);
    var emptyEl = q('[data-aw-salon-list-empty]', root);
    if (!grid) return;

    var cards = qa('.aw-salon-list-card', grid);

    var searchPanel = q('[data-aw-salon-filter]');
    var activeAreaGroups = [];
    var activeBrands = [];
    var activeMenu = [];
    var activeFeatures = [];
    var activeProducts = [];
    var activeKeyword = '';

    var listState = window.awListState;
    var stateKey = 'aw-salon-list-state';
    var stateReady = false;
    var detailPaths = listState ? listState.detailPaths(cards) : [];
    var applySavedState = function () {};
    if (listState) listState.claimScroll(stateKey);

    var matchesFilters = function (card) {
      if (activeAreaGroups.length && activeAreaGroups.indexOf(card.dataset.area || '') === -1) return false;

      if (activeBrands.length && activeBrands.indexOf(card.dataset.brand || '') === -1) return false;

      if (!includesAll(splitTags(card.dataset.features), activeFeatures.concat(activeMenu))) return false;
      if (!includesAll(splitTags(card.dataset.productsHandled), activeProducts)) return false;

      if (activeKeyword !== '') {
        if (normalize(card.textContent).indexOf(normalize(activeKeyword)) === -1) return false;
      }

      return true;
    };

    var sortCards = function () {
      cards.sort(function (a, b) {
        return Number(a.dataset.displayOrder || 999999) - Number(b.dataset.displayOrder || 999999);
      });
      cards.forEach(function (card) {
        grid.appendChild(card);
      });
      if (emptyEl) grid.appendChild(emptyEl);
    };

    var render = function () {
      var visible = cards.filter(matchesFilters);

      if (countEl) countEl.textContent = String(visible.length);

      cards.forEach(function (card) {
        card.classList.add('is-hidden');
      });
      visible.forEach(function (card) {
        card.classList.remove('is-hidden');
      });

      if (emptyEl) emptyEl.hidden = visible.length > 0;
      saveState();
    };

    var saveState = function () {
      if (!listState || !stateReady) return;
      listState.write(stateKey, {
        areas: activeAreaGroups,
        brands: activeBrands,
        menu: activeMenu,
        features: activeFeatures,
        products: activeProducts,
        keyword: activeKeyword
      });
    };

    var toggleInArray = function (list, value, isActive) {
      var index = list.indexOf(value);
      if (isActive && index === -1) list.push(value);
      if (!isActive && index !== -1) list.splice(index, 1);
    };

    var initSearchPanel = function () {
      if (!searchPanel) return;

      var form = q('[data-aw-salon-filter-form]', searchPanel);
      var keywordInput = searchPanel.querySelector('.aw-search-panel__search-input');

      var clearAreaQueryParam = function () {
        if (!window.history || !window.history.replaceState) return;
        var url = new URL(window.location.href);
        if (!url.searchParams.has('area')) return;
        url.searchParams.delete('area');
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
      };

      var initMultiToggle = function (selector, targetList) {
        var buttons = qa(selector, searchPanel);
        buttons.forEach(function (button) {
          button.addEventListener('click', function () {
            var isActive = !button.classList.contains('aw-search-panel__toggle--active');
            button.classList.toggle('aw-search-panel__toggle--active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            toggleInArray(targetList, button.dataset.salonArea || button.dataset.salonBrand, isActive);
            clearAreaQueryParam();
            render();
          });
        });
        return buttons;
      };

      var areaButtons = initMultiToggle('[data-salon-area]', activeAreaGroups);
      var brandButtons = initMultiToggle('[data-salon-brand]', activeBrands);

      var applyAreaFromQuery = function () {
        var areaParam = new URLSearchParams(window.location.search).get('area');
        if (!areaParam) return;

        areaButtons.forEach(function (button) {
          if (button.dataset.salonArea !== areaParam) return;
          button.classList.add('aw-search-panel__toggle--active');
          button.setAttribute('aria-pressed', 'true');
          toggleInArray(activeAreaGroups, button.dataset.salonArea, true);
        });
      };

      applyAreaFromQuery();

      var initCheckboxGroup = function (name, targetList) {
        var checkboxes = qa('input[name="' + name + '"]', searchPanel);
        checkboxes.forEach(function (checkbox) {
          checkbox.addEventListener('change', function () {
            toggleInArray(targetList, checkbox.value, checkbox.checked);
            clearAreaQueryParam();
            render();
          });
        });
        return checkboxes;
      };

      var menuCheckboxes = initCheckboxGroup('menu', activeMenu);
      var featureCheckboxes = initCheckboxGroup('feature', activeFeatures);
      var productCheckboxes = initCheckboxGroup('products_handled', activeProducts);

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          activeKeyword = keywordInput ? keywordInput.value : '';
          clearAreaQueryParam();
          render();
        });
      }

      var clearButton = q('[data-aw-salon-filter-clear]', searchPanel);
      if (clearButton) {
        clearButton.addEventListener('click', function () {
          areaButtons.concat(brandButtons).forEach(function (button) {
            button.classList.remove('aw-search-panel__toggle--active');
            button.setAttribute('aria-pressed', 'false');
          });
          menuCheckboxes.concat(featureCheckboxes, productCheckboxes).forEach(function (checkbox) {
            checkbox.checked = false;
          });
          if (keywordInput) keywordInput.value = '';
          activeAreaGroups.length = 0;
          activeBrands.length = 0;
          activeMenu.length = 0;
          activeFeatures.length = 0;
          activeProducts.length = 0;
          activeKeyword = '';
          clearAreaQueryParam();
          render();
        });
      }

      applySavedState = function (saved) {
        var asList = function (value) {
          return Array.isArray(value) ? value : [];
        };

        var restoreToggles = function (buttons, attribute, values, target) {
          buttons.forEach(function (button) {
            var isActive = values.indexOf(button.dataset[attribute]) !== -1;
            button.classList.toggle('aw-search-panel__toggle--active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            if (isActive) toggleInArray(target, button.dataset[attribute], true);
          });
        };

        var restoreChecks = function (checkboxes, values, target) {
          checkboxes.forEach(function (checkbox) {
            var isActive = values.indexOf(checkbox.value) !== -1;
            checkbox.checked = isActive;
            if (isActive) toggleInArray(target, checkbox.value, true);
          });
        };

        restoreToggles(areaButtons, 'salonArea', asList(saved.areas), activeAreaGroups);
        restoreToggles(brandButtons, 'salonBrand', asList(saved.brands), activeBrands);
        restoreChecks(menuCheckboxes, asList(saved.menu), activeMenu);
        restoreChecks(featureCheckboxes, asList(saved.features), activeFeatures);
        restoreChecks(productCheckboxes, asList(saved.products), activeProducts);
        activeKeyword = typeof saved.keyword === 'string' ? saved.keyword : '';
        if (keywordInput) keywordInput.value = activeKeyword;
      };
    };

    var restoreState = function () {
      if (!listState) return null;
      var touched = activeAreaGroups.length || activeBrands.length || activeMenu.length || activeFeatures.length || activeProducts.length || activeKeyword !== '';
      var loaded = touched ? null : listState.load(stateKey, detailPaths);
      if (loaded) applySavedState(loaded.state);
      return loaded;
    };

    sortCards();
    initSearchPanel();
    var restored = restoreState();
    stateReady = true;
    render();
    if (listState) {
      listState.finish(restored);
      window.addEventListener('pagehide', saveState);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-salon-list]'), initSalonList);
  });
})();
